
const common = {
  state: {
    menuCodeTop: {},
  },
  getters: {
    menuCodeTop (state) { //
      return state.menuCodeTop
    },
  },
  mutations: {
    setMenuCodeTop (state, info) {
      state.menuCodeTop = info
    },
  },
  actions: {
    upMenuCodeTop({commit}){
        commit('setMenuCodeTop')
    },
  }
}

export default common